/**
 * ehr#458 (Chase 10-16): app-wide events between a note and Data & settings, without prop-drilling.
 *   OPEN_DATA_SETTINGS { section }: App opens Data & settings on that rail section ('clinical').
 *   CLINICAL_SETTINGS_CHANGED: Data & settings saved the Clinical notes settings; an open note
 *   re-reads them (dictation on or off).
 */
export const OPEN_DATA_SETTINGS = 'credify:open-data-settings';
export const CLINICAL_SETTINGS_CHANGED = 'credify:clinical-settings-changed';
/** ehr#492: Data & settings saved Branding & labels; the sidebar, titles and buttons re-read them. */
export const BRANDING_CHANGED = 'credify:branding-changed';

export function openDataSettings(section: string): void {
  window.dispatchEvent(new CustomEvent(OPEN_DATA_SETTINGS, { detail: { section } }));
}
